import { render } from "./BlockCounterEdit.vue?vue&type=template&id=469c07fe"
import script from "./BlockCounterEdit.vue?vue&type=script&lang=js"
export * from "./BlockCounterEdit.vue?vue&type=script&lang=js"
script.render = render

export default script